import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Spinner } from 'react-bootstrap';
import SEO from '../../components/seo';
import { useDispatch, useSelector } from 'react-redux';
import { authSelector, login } from '../../store/slices/auth-slice';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import config from '../../utils/config';

const Login = () => {
  const {t} = useTranslation();
  const { isLoading } = useSelector(authSelector);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const onSubmit = (data) => {
    dispatch(
      login({
        ...data,
        navigate,
      })
    );
  };

  return (
    <>
      <SEO titleTemplate={t("Login")} description={t("Login page.")} />
      <Container fluid className="login-page">
        <Row className="login-page__row align-items-center">
          {/* Left Side: Brand & Illustration */}
          <Col md={6} lg={7} className="d-none d-md-block">
            <div className="login-hero">
              <img
                src={config.logoUrl}
                alt={t("Logo")}
                className="login-hero__logo"
              />
              <h1 className="login-hero__title">{t("B2B Reserved area")}</h1>
              <p className="login-hero__subtitle">
                {t("Order management and stock availability.")}
              </p>
              <div className="login-hero__illustration">
                <img
                  src={config.loginIllustrationUrl}
                  alt={t("Illustration")}
                  className="img-fluid"
                />
              </div>
            </div>
          </Col>

          {/* Right Side: Login Form */}
          <Col md={6} lg={5} xl={4} className="ms-auto">
            <div className="login-card">
              {/* Logo */}
              <div className="text-center mb-4">
                <img
                  src={config.logoUrl}
                  alt={t("Logo")}
                  className="login-card__logo"
                />
              </div>

              {/* Title */}
              <h2 className="login-card__title">{t("Sign in")}</h2>
              <p className="login-card__subtitle">
                {t("Enter your credentials to continue.")}
              </p>

              <Form onSubmit={handleSubmit(onSubmit)} noValidate>
                {/* Username Field */}
                <Form.Group className="mb-3" controlId="userLoginId">
                  <Form.Label>{t("Username")}</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder={t("Username")}
                    isInvalid={!!errors.userLoginId}
                    {...register('userLoginId', { required: true })}
                  />
                  {errors.userLoginId && (
                    <div className="text-danger mt-1">
                      {t("Username is required!")}
                    </div>
                  )}
                </Form.Group>

                {/* Password Field with SHOW/HIDE Icon */}
                <Form.Group className="mb-3" controlId="password">
                  <Form.Label>{t("Password")}</Form.Label>
                  <div className="login-card__password">
                    <Form.Control
                      type={showPassword ? 'text' : 'password'}
                      placeholder={t("Password")}
                      isInvalid={!!errors.password}
                      {...register('password', { required: true })}
                    />
                    <button
                      type="button"
                      className="login-card__toggle"
                      onClick={() => setShowPassword(!showPassword)}
                      aria-label={t("Password")}
                    >
                      <i
                        className={`fa ${
                          showPassword ? 'fa-eye-slash' : 'fa-eye'
                        }`}
                      />
                    </button>
                  </div>
                  {errors.password && (
                    <div className="text-danger mt-1">
                      {t("Password is required!")}
                    </div>
                  )}
                </Form.Group>

                {/* Tenant Field 
                <Form.Group className="mb-3" controlId="tenantId">
                  <Form.Label>{t("Tenant ID")}</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder={t("Tenant ID")}
                    isInvalid={!!errors.tenantId}
                    {...register('tenantId', { required: false })}
                  />
                  {errors.tenantId && (
                    <div className="text-danger mt-1">
                      {t("Tetant is required!")}
                    </div>
                  )}
                </Form.Group>
                */}

                {/* Remember Me & Forgot Password */}
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <Form.Group controlId="rememberMe" className="mb-0">
                    <Form.Check type="checkbox" label={t("Remember me")} />
                  </Form.Group>
                  {/* <a href="#forgot-password" className="login-card__link">
                    Forgot Password?
                  </a> */}
                </div>

                {/* Login Button */}
                <Button
                  type="submit"
                  className="login-card__submit w-100"
                  disabled={isLoading}
                >
                  {isLoading && (
                    <Spinner
                      as="span"
                      animation="grow"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="mx-2"
                    />
                  )}{' '}
                  {t("Log In")}
                </Button>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Login;
